import keyMirror from 'keymirror'

export default keyMirror({
  GET_PORTAL_USER_LIST_SUCCESS: null,
  GET_PORTAL_USER_LIST_REQUEST: null,
  GET_PORTAL_USER_LIST_FAILED: null,

  GET_PORTAL_USER_DETAIL_SUCCESS: null,
  GET_PORTAL_USER_DETAIL_REQUEST: null,
  GET_PORTAL_USER_DETAIL_FAILED: null,

  ADD_PORTAL_USER_REQUEST: null,
  ADD_PORTAL_USER_SUCCESS: null,
  ADD_PORTAL_USER_FAILED: null,

  UPDATE_PORTAL_USER_REQUEST: null,
  UPDATE_PORTAL_USER_SUCCESS: null,
  UPDATE_PORTAL_USER_FAILED: null,

  UPSERT_GDPR_PORTAL_USER_REQUEST: null,
  UPSERT_GDPR_PORTAL_USER_SUCCESS: null,
  UPSERT_GDPR_PORTAL_USER_FAILED: null,

  GET_GDPR_PORTAL_USER_REQUEST: null,
  GET_GDPR_PORTAL_USER_SUCCESS: null,
  GET_GDPR_PORTAL_USER_FAILED: null,

  GET_VEHICLE_PORTAL_USER_REQUEST: null,
  GET_VEHICLE_PORTAL_USER_SUCCESS: null,
  GET_VEHICLE_PORTAL_USER_FAILED: null,

  GET_COMPANIES_PORTAL_USER_REQUEST: null,
  GET_COMPANIES_PORTAL_USER_SUCCESS: null,
  GET_COMPANIES_PORTAL_USER_FAILED: null,

  GET_PORTAL_USER_PORTAL_ROLE_SUCCESS: null,
  GET_PORTAL_USER_PORTAL_ROLE_REQUEST: null,
  GET_PORTAL_USER_PORTAL_ROLE_FAILED: null,

  GET_ROLE_PORTAL_USER_REQUEST: null,
  GET_ROLE_PORTAL_USER_SUCCESS: null,
  GET_ROLE_PORTAL_USER_FAILED: null,

  UPDATE_ROLE_PORTAL_USER_REQUEST: null,
  UPDATE_ROLE_PORTAL_USER_SUCCESS: null,
  UPDATE_ROLE_PORTAL_USER_FAILED: null,

  GET_DIRECT_VEHICLES_PORTAL_USER_REQUEST: null,
  GET_DIRECT_VEHICLES_PORTAL_USER_SUCCESS: null,
  GET_DIRECT_VEHICLES_PORTAL_USER_FAILED: null,

  CANCEL_DIRECT_VEHICLE_PORTAL_USER_REQUEST: null,
  CANCEL_DIRECT_VEHICLE_PORTAL_USER_SUCCESS: null,
  CANCEL_DIRECT_VEHICLE_PORTAL_USER_FAILED: null,

  GET_COMM_SYSTEM_LOGS_PORTAL_USER_REQUEST: null,
  GET_COMM_SYSTEM_LOGS_PORTAL_USER_SUCCESS: null,
  GET_COMM_SYSTEM_LOGS_PORTAL_USER_FAILED: null,

  UPDATE_FILTER_PORTAL_USER_SUCCESS: null
})
